import { plainToInstance } from 'class-transformer'
import i18n from 'vue-i18n'

import { BaseNodeModelData } from '../../Nodes/BaseNode/BaseNodeDataModel'
import { BaseNodeModel } from '../../Nodes/BaseNode/BaseNodeModel'
import CustomNode from '../../Nodes/CustomNode'
import CustomNodeComponent from '../../Nodes/CustomNodeComponent'
import { NodeTypes } from '../../Nodes/NodesTypes'
import StartSampleNode from './SampleStartNode.vue'

export default class StartNodeBuilder extends CustomNodeComponent {
  menuSection = null

  getBaseNodeModel = ([ x, y ]: [number, number]) => {
    return {
      data: plainToInstance(StartNodeData, { type: NodeTypes.Start }),
      output: CustomNode.LastSocketId += 1,
      input: CustomNode.LastSocketId += 1,
      color: null,
      x,
      y,
    }
  }

  constructor(i18n: i18n) {
    super(StartSampleNode, StartNode, NodeTypes.Start, i18n)
  }
}

export class StartNode extends CustomNode {
  data: StartNodeData

  constructor(name: NodeTypes.Start, model: BaseNodeModel) {
    super(name, model)

    if (model.data instanceof StartNodeData) {
      this.data = model.data
    } else {
      throw new Error('To node come unknown data')
    }
  }
}

export class StartNodeData extends BaseNodeModelData {
  declare type: NodeTypes.Start
}
